export default __webpack_public_path__ + "static/media/vocals2.af62bc18.wav";